import "./App.css";
import "./fonts/stylesheet.css";
import "animate.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import community from "./images/community.png";
import anniversary50 from "./images/50.png";
import celebration from "./images/celebration.png";
import qr from "./images/qr.png";

function App() {
  const baseUrl =
    "https://wj8skdta4j.execute-api.us-east-1.amazonaws.com/dev/read?timestamp=";

  const [responses, setResponses] = useState([]);
  const [lastTimeStamp, setLastTimeStamp] = useState("");
  const [currentStory, setCurrentStory] = useState({});
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  let sliderIndex = 0;

  const config = {
    headers: {
      "x-api-key": "uC00c7BDaz6q65MPInKTo2ckrWIIMpdP8cYl6kcb",
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (responses.length > 0) {
        if (typeof responses[sliderIndex] === "undefined") {
          sliderIndex = 0;
          setStory(sliderIndex);
        } else {
          setStory(sliderIndex);
          sliderIndex++;
        }
      }
    }, 15000);

    return () => clearInterval(interval);
  }, [responses]);

  function setStory(index) {
    if (responses.length > 0) {
      var img2 = new Image();
      img2.onload = function () {
        // this will run when the image is ready
        setCurrentStory(responses[index]);
        setIsImageLoaded(true);
      };
      img2.src = responses[index].public_image_link;
    }
  }

  useEffect(() => {
    const interval2 = setInterval(() => {
      console.log("getting new data from API");
      getData();
    }, 30000);
    return () => clearInterval(interval2);
  }, [lastTimeStamp]);

  useEffect(() => {
    setTimeout(() => {
      getData();
    }, 5000);
  }, []);

  const getData = () => {
    let timestamp = "2022-04-27T10:29:00";
    if (lastTimeStamp != "") {
      timestamp = lastTimeStamp;
    }

    axios
      .get(`${baseUrl}${timestamp}`, config)
      .then(function (response) {
        if (response.data.response && response.data.response.length > 0) {
          setResponses((responses) => [
            ...responses,
            ...response.data.response,
          ]);
          sliderIndex = responses.length;
          setLastTimeStamp(
            response.data.response[response.data.response.length - 1].timestamp
          );
          setStory(sliderIndex);
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  };

  const getFontSizeBasedOnCharacters = (text) => {
    const textLenght = text.length;
    if (textLenght < 50) {
      return "4rem";
    }
    if (textLenght > 50 && textLenght < 100) {
      return "3.8rem";
    }
    if (textLenght > 100 && textLenght < 200) {
      return "3.5rem";
    }
    if (textLenght > 200 && textLenght < 400) {
      return "2.8rem";
    }
    if (textLenght > 400 && textLenght < 600) {
      return "2.5rem";
    }
    if (textLenght > 600 && textLenght < 800) {
      return "2rem";
    }
    if (textLenght > 800 && textLenght < 1000) {
      return "1.6rem";
    }
    return "1rem";
  };

  return (
    <div className="App">
      <div id="wrapper">
        <div className="grid3columns header">
          <div>
            <img src={community} />
          </div>
          <div>
            <img src={anniversary50} />
          </div>
          <div>
            <img src={celebration} />
          </div>
        </div>
        {isImageLoaded && (
          <>
            {currentStory.hope != "" && (
              <div className="hopeContainer">
                <div
                  className={`hope`}
                  style={{
                    fontSize: getFontSizeBasedOnCharacters(currentStory.hope),
                  }}
                >
                  {currentStory.hope}
                </div>
              </div>
            )}
            <div className="imagewrapper">
              <div
                className="image"
                style={{
                  backgroundImage:
                    "url(" + currentStory.public_image_link + ")",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
            </div>
          </>
        )}
        <div className={`noResponsesYet ${isImageLoaded && "fixedQr"}`}>
          <div className="grid2columns">
            <div>
              <div className="lightFont">
                You´re an important part of our history and our future.
              </div>
              <div>Share your thoughts here</div>
            </div>
            <div>
              <img className="qrCode" src={qr} />
            </div>
          </div>
          <div className="participate">
            <a
              href="https://script.google.com/macros/s/AKfycbzqjrbnWguTrQIwa1GpZITZMQj2qdjIlLuue2kHQ2J0n4cYazm-THX_FW46WYi6rmE4/exec"
              target={"_blank"}
            >
              Participate here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
